import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerContainer: {
      padding: theme.spacing(1),
      backgroundColor: theme.palette.background.paper,
      maxHeight: 81,
    },
    headerContent: {
      marginLeft: theme.spacing(3),
    },
    logoMedium: {
      width: 143,
      height: 48,
    },
    logoSmall: {
      width: 50,
      height: 50,
    },
    avatar: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
    divider: {
      height: 40,
    },
    headerIcon: {
      color: `${theme.palette.grey[500]}`,
    },
  }),
);

export default useStyles;
